// Mock data for KISAT Media landing page

export const heroData = {
  headline: "Trusted by Brands, Creators & Institutions",
  subheadline: "KISAT Media has partnered with businesses, colleges, and organizations to deliver impactful social media marketing, content creation, and digital growth.",
  cta1: "Work With Us",
  cta2: "View Our Clients",
  backgroundImage: "https://images.unsplash.com/photo-1758873268663-5a362616b5a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwdGVhbSUyMGNvbGxhYm9yYXRpb24lMjBtb2Rlcm58ZW58MHx8fHwxNzczMTY4MzM4fDA&ixlib=rb-4.1.0&q=85"
};

export const aboutData = {
  title: "About KISAT Media",
  description: "KISAT Media is a content-driven digital marketing agency specializing in social media management, reels production, creative graphics, and digital campaigns. We collaborate with brands, institutions, and agencies to help them grow their online presence and reach the right audience.",
  services: [
    {
      id: 1,
      icon: "Share2",
      title: "Social Media Management",
      description: "Strategic content planning and community engagement"
    },
    {
      id: 2,
      icon: "Sparkles",
      title: "Content Creation",
      description: "High-quality graphics and engaging copy"
    },
    {
      id: 3,
      icon: "Video",
      title: "Video Production",
      description: "Professional reels and promotional videos"
    },
    {
      id: 4,
      icon: "Target",
      title: "Digital Campaigns",
      description: "Data-driven marketing strategies"
    },
    {
      id: 5,
      icon: "TrendingUp",
      title: "Brand Growth Strategy",
      description: "Long-term planning for sustainable growth"
    },
    {
      id: 6,
      icon: "Star",
      title: "Influencer Marketing",
      description: "Strategic collaborations with content creators"
    }
  ]
};

export const clientsData = {
  title: "Our Clients",
  caption: "Brands and institutions that trust KISAT Media.",
  clients: [
    { 
      id: 1, 
      name: "Skoda", 
      logo: "SK", 
      logoImage: "https://customer-assets.emergentagent.com/job_agency-showcase-96/artifacts/ntl8coj0_%C5%A0koda_nieuw.png",
      category: "Automobile" 
    },
    { 
      id: 2, 
      name: "Ecowater", 
      logo: "EW", 
      logoImage: "https://customer-assets.emergentagent.com/job_agency-showcase-96/artifacts/9xieh72x_EcoWater%20Logo%20Wide.png",
      category: "Food & Beverages" 
    },
    { 
      id: 3, 
      name: "Jinvani Management College", 
      logo: "JMC", 
      logoImage: "https://customer-assets.emergentagent.com/job_agency-showcase-96/artifacts/l3d46c8u_JMC_Logo_with_WHite_BG-removebg-preview.png",
      category: "Education" 
    },
    { 
      id: 4, 
      name: "Gyan Jyoti Awasiya Vidyalaya", 
      logo: "GJAV", 
      logoImage: "https://customer-assets.emergentagent.com/job_agency-showcase-96/artifacts/916iy7n9_Logo%20PNG%20NEW.png",
      category: "Education" 
    },
    { 
      id: 5, 
      name: "Corporate Strikers", 
      logo: "CS", 
      logoImage: "https://customer-assets.emergentagent.com/job_agency-showcase-96/artifacts/8j59wumj_CS%20with%20Stroke.png",
      category: "Sports" 
    },
    { 
      id: 6, 
      name: "Zarkala", 
      logo: "ZK", 
      logoImage: "https://customer-assets.emergentagent.com/job_agency-showcase-96/artifacts/5ud8dw09_Zarkala%20512px.png",
      category: "Ecommerce" 
    },
    { 
      id: 7, 
      name: "Fixit", 
      logo: "FX", 
      logoImage: "https://customer-assets.emergentagent.com/job_agency-showcase-96/artifacts/1pcsigke_fixit-dak-bunglow-patna-mobile-phone-repair-and-services-841llxz3s8-250.avif",
      category: "Mobile Repair Services" 
    },
    { 
      id: 8, 
      name: "SmartFix India", 
      logo: "SF", 
      logoImage: "/smartfix_india.png",
      category: "Home Services" 
    },
    { 
      id: 9, 
      name: "Eurokids", 
      logo: "EK", 
      logoImage: "https://customer-assets.emergentagent.com/job_agency-showcase-96/artifacts/1j3g3csj_WhatsApp_Image_2023-12-15_at_5.01.13_PM-removebg-preview.png",
      category: "Education" 
    },
    { id: 10, name: "Finance Mantra", logo: "FM", category: "Personal Brand" },
    { 
      id: 11, 
      name: "Enspire Talks", 
      logo: "ET", 
      logoImage: "/enspire_talks.png",
      category: "Personal Brand" 
    },
    { 
      id: 12, 
      name: "TVS", 
      logo: "TVS", 
      logoImage: "/tvs_logo.png",
      category: "Automobile" 
    },
    { id: 13, name: "Aditya Bijay Jain", logo: "ABJ", category: "Personal Brand" },
    { 
      id: 14, 
      name: "Bihar T10 League", 
      logo: "BT10", 
      logoImage: "/bihar_t10.png",
      category: "Sports" 
    }
  ]
};

export const projectsData = {
  title: "Featured Projects",
  subtitle: "Case Highlights",
  projects: [
    {
      id: 1,
      clientName: "Corporate Strikers",
      workType: "Social Media Management and Content Creation",
      result: "Created quality short form content for better engagement",
      image: "/corporate_strikers.png",
      metrics: { engagement: "+350%", reach: "500K+" }
    },
    {
      id: 2,
      clientName: "Ecowater",
      workType: "Social Media Management and Content Creation",
      result: "Created quality short form content for better engagement",
      image: "/ecowater.png",
      metrics: { engagement: "+110%", reach: "300K+" }
    },
    {
      id: 3,
      clientName: "Zarkala",
      workType: "Content Creation and Influencer Campaigns",
      result: "Created quality short form content for better engagement and helped to collaborate with relative influencers",
      image: "/zarkala.png",
      metrics: { engagement: "+150%", reach: "650K+" }
    }
  ]
};

export const collaborationsData = {
  title: "Agency Collaborations",
  subtitle: "Our Partners",
  description: "KISAT Media believes in collaboration. We partner with agencies, freelancers, and creators to deliver high-quality marketing campaigns.",
  partners: [
    { id: 1, name: "Metagrafix", logo: "MG" },
    { id: 2, name: "Digitec Solutions", logo: "DS" },
    { id: 3, name: "MarketoVeda", logo: "MV" },
    { id: 4, name: "Devout Growth", logo: "DG" },
    { id: 5, name: "Trimurti Publicity", logo: "TP" },
    { id: 6, name: "Exposure Hub", logo: "EH" }
  ]
};

export const testimonialsData = {
  title: "What Our Clients Say",
  testimonials: [
    {
      id: 1,
      name: "Ankit Kumar",
      company: "Enspire Talks",
      role: "Host",
      feedback: "KISAT Media transformed our social media presence. Their content quality and strategic approach helped us grow our community significantly.",
      rating: 5,
      avatar: "AK"
    },
    {
      id: 2,
      name: "Sidh Bijay Jain",
      company: "Jinvani Management College",
      role: "Director",
      feedback: "Professional, creative, and results-driven. KISAT Media understood our needs and delivered exceptional campaigns that boosted our student inquiries.",
      rating: 5,
      avatar: "SJ"
    },
    {
      id: 3,
      name: "Binit Baibhav",
      company: "Corporate Strikers League",
      role: "Working President",
      feedback: "The team's ability to create engaging content and manage our social channels during events was outstanding. Highly recommend!",
      rating: 5,
      avatar: "BB"
    },
    {
      id: 4,
      name: "Ravikant Arya",
      company: "Ecowater",
      role: "Co-Founder",
      feedback: "KISAT Media helped us build a loyal online community. Their creative reels and consistent posting schedule made a real difference.",
      rating: 5,
      avatar: "RA"
    }
  ]
};

export const ctaData = {
  headline: "Let's Grow Your Brand Together",
  description: "Looking for a reliable digital marketing partner? KISAT Media is ready to help.",
  cta1: "Start a Project",
  cta2: "Collaborate With Us"
};

export const footerData = {
  about: "KISAT Media is a content-driven digital marketing agency helping brands grow their online presence through strategic social media management and creative content.",
  sections: [
    {
      title: "Quick Links",
      links: [
        { label: "About", href: "#about" },
        { label: "Services", href: "#services" },
        { label: "Clients", href: "#clients" },
        { label: "Projects", href: "#projects" },
        { label: "Contact", href: "#contact" }
      ]
    },
    {
      title: "Services",
      links: [
        { label: "Social Media Management", href: "#services" },
        { label: "Content Creation", href: "#services" },
        { label: "Video Production", href: "#services" },
        { label: "Digital Campaigns", href: "#services" },
        { label: "Brand Strategy", href: "#services" }
      ]
    }
  ],
  social: [
    { platform: "Instagram", icon: "Instagram", url: "https://instagram.com/kisatmedia" },
    { platform: "LinkedIn", icon: "Linkedin", url: "https://www.linkedin.com/company/kisat-media" },
    { platform: "YouTube", icon: "Youtube", url: "https://youtube.com/@kisatmedia" },
    { platform: "Facebook", icon: "Facebook", url: "https://facebook.com/kisatmedia" }
  ],
  contact: {
    email: "hello@kisatmedia.in",
    phone: "+91 7739303973"
  }
};
